import manifest_45route_45rule from "/application/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}